import { createAction } from '@helpers/createAction'

export const DASHBOARD_STUDENT = 'DASHBOARD_STUDENT'

export default {
  [DASHBOARD_STUDENT]: createAction(DASHBOARD_STUDENT),
}
